import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useEffect, useState } from "react";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import * as authSelectors from "../../selectors/auth";
import clsx from "clsx";
import PAGE from "../../utils/Destination";
import { useHistory } from "react-router";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalculator, faCircleChevronRight, faQuestion, faQuestionCircle} from "@fortawesome/free-solid-svg-icons";

function UserGuide({generalData}) {
    const [token, setToken] = useState(null);
    const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
    const history = useHistory();

    useEffect(() => {
        setTokenFunction();
    }, [isLogout]);

    async function setTokenFunction() {
        setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
    }
    const onClickNavigate = (e, page, queryParam) => {
        e.preventDefault();
        history.push(`${page}${!_.isEmpty(queryParam) ? `?${queryParam}` : ""}`);
    };

    return (
        <Container fluid className="pb-5">
            <div className={"primary-border-table-border"} style={{backgroundColor: "white"}}>
                <div className={clsx("d-flex custom-card-label-container align-items-center")}>
                    <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className="fa-2x"
                        style={{marginRight: "10px", color: "white"}}
                    />
                    <h2>User Guide</h2>
                </div>
                <div>
                    <a
                        className="user-guide-link"
                        href={`${PAGE.SET_OFF_GUIDE}`}
                        onClick={(e) => {
                            e.preventDefault()
                            onClickNavigate(e, PAGE.SET_OFF_GUIDE)
                        }
                        }
                    >
                        How do I perform e-Setoff?{" "}
                        <FontAwesomeIcon icon={faCircleChevronRight} style={{marginLeft: "10px"}}/>
                    </a>
                    <a
                        className="user-guide-link"
                        href={`${PAGE.PAYMENT_GUIDE}`}
                        onClick={(e) => {
                            e.preventDefault()
                            onClickNavigate(e, PAGE.PAYMENT_GUIDE)
                        }
                        }
                    >
                        How do I perform e-Payment?{" "}
                        <FontAwesomeIcon icon={faCircleChevronRight} style={{marginLeft: "10px"}}/>
                    </a>
                    <a
                        className="user-guide-link"
                        href={`${PAGE.WITHDRAW_GUIDE}`}
                        onClick={(e) => {
                            e.preventDefault()
                            onClickNavigate(e, PAGE.WITHDRAW_GUIDE)
                        }
                        }
                    >
                        How do I perform e-Withdraw?{" "}
                        <FontAwesomeIcon icon={faCircleChevronRight} style={{marginLeft: "10px"}}/>
                    </a>
                    <a
                        className="user-guide-link"
                        href={`${PAGE.DEPOSIT_GUIDE}`}
                        onClick={(e) => {
                            e.preventDefault()
                            onClickNavigate(e, PAGE.DEPOSIT_GUIDE)
                        }
                        }
                    >
                        How do I perform e-Deposit?{" "}
                        <FontAwesomeIcon icon={faCircleChevronRight} style={{marginLeft: "10px"}}/>
                    </a>
                </div>
            </div>
        </Container>
    );
}

export default UserGuide;
